import * as CertificationWatermark from '@tableau/certification-watermark';
import { FormattedMarkupWrapperInTooltip } from '@tableau/data-catalog-client-components';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { FeatureFlags } from '~src/ts/FeatureFlags';

export function CertificationMarkTooltipCell(
    isCertified: (row: DataGrid.Row) => boolean,
    getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps
): React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    displayName: 'CertificationMarkTooltipCell';

    render() {
      if (isCertified(this.props.row)) {
        const tooltipProps = getTooltipProps(this.props.row);
        return <CertificationWidgetRipoff {...tooltipProps} />;
      } else {
        return <span></span>;
      }
    }
  });
}

/**
 * This is a ripoff of CertificationWidget in data-catalog-shared, assumes is certified since
 * this cell doesn't render when the content item isn't certified.
 */
function CertificationWidgetRipoff(props: CertificationWatermark.CertificationTooltipProps) {
  const renderedMarkupOrString = FeatureFlags.markupEditingEnabled ?
    (typeof props.note === 'string' ? <FormattedMarkupWrapperInTooltip markup={props.note} /> : props.note) :
    props.note;

  return (
    <CertificationWatermark.CertificationTooltipComponent {...props} note={renderedMarkupOrString} />
  );
}
